<template>
  <div>
    <div class="card">
      <div class="py-3 px-4">
        <div class="d-flex align-items-center justify-content-between g-4">
          <i class="fa-duotone fa-line-height text-foreground" style="font-size: 1.8em"></i>
          <div class="d-flex align-items-center g-2">
            <ButtonView v-for="option in limitOptions" :key="option" type="soft" color="primary" :active="limit === option" @click="emit('update:limit', option)">
              {{ option }}
            </ButtonView>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="py-3 px-4">
        <div class="d-flex align-items-center justify-content-between g-4">
          <i class="fa-duotone fa-book-open text-foreground" style="font-size: 1.8em"></i>
          <InputView type="text" v-model:value="pageInput" @blur="pageInputBlurred" placeholder="5" style="max-width: 130px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import ButtonView from "../general/ButtonView.vue";
import InputView from "../forms/inputs/InputView.vue";

const props = defineProps({
  limit: Number,
  total: Number,
  page: Number
});

const emit = defineEmits(["update:limit", "update:page"]);

const pageInput = ref(props.page);

const limitOptions = computed(() => {
  return (props.limit ? [...(new Set([props.limit, 10, 20, 30, 40, 50]))].sort((a, b) => a - b) : [10, 20, 30, 40, 50]).filter(item => item < (props.total + 10));
});

function pageInputBlurred() {
  const intValue = parseInt(pageInput.value);
  if (intValue && props.page !== intValue) {
    if (intValue > 0 && intValue <= Math.ceil(props.total / props.limit)) {
      emit('update:page', intValue);
    } else {
      pageInput.value = String(props.page);
    }
  }
}
</script>